import {
  FormLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Typography,
  Divider,
  Icon,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import CustomMaskedInput from 'components/MaskedInput';
import { functions } from 'helpers/functions';
import React, { Fragment } from 'react';

import styles from '../../styles';

interface IPropsState {
  paymentMethods: {
    credit_card: number;
    bankslip: number;
    paypal: number;
    pix: number;
  };
  purchaseValue: string;
}

interface IProps {
  state: IPropsState;
  classes?: any;
  handleRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCustomValue: (value: any, number: any) => void;
  checkCustomValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const customValuesRender = [
  {
    label: 'Cartão de crédito',
    key: 'credit_card',
  },
  {
    label: 'Boleto',
    key: 'bankslip',
  },
  {
    label: 'Paypal',
    key: 'paypal',
  },
  {
    label: 'Pix',
    key: 'pix',
  },
];

function SendValues({ state, classes, handleRadioChange, handleCustomValue, checkCustomValue }: IProps) {
  const { paymentMethods, purchaseValue } = state;

  return (
    <Fragment>
      <div className='m24' />
      <FormControl className={classes.formControl}>
        <FormLabel>Escolha em que situações o valor da compra deve ser enviado.</FormLabel>
        <div className='m16' />
        <RadioGroup aria-label='Gender' name='gender1' className={classes.group} value={purchaseValue} onChange={handleRadioChange}>
          <FormControlLabel value='never' control={<Radio checked={Boolean(purchaseValue === 'never')} />} label='Nunca enviar' />
          <FormControlLabel
            value='send_purchase_value'
            control={<Radio checked={Boolean(purchaseValue === 'send_purchase_value')} />}
            label='Sempre enviar'
          />
          <FormControlLabel
            value='custom_values'
            control={<Radio checked={Boolean(purchaseValue === 'custom_values')} />}
            label='Sempre enviar com valores customizados'
          />
        </RadioGroup>
        {purchaseValue === 'custom_values' && (
          <Fragment>
            <div className='m16' />
            <Divider />
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Forma de Pagamento</TableCell>
                  <TableCell>Valor a ser enviado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                {customValuesRender.map((customValue) => (
                  <TableRow key={customValue.key}>
                    <TableCell>
                      <FormControlLabel
                        control={<Checkbox checked={paymentMethods[customValue.key] > 0} onChange={checkCustomValue} value={customValue.key} />}
                        label={customValue.label}
                      />
                    </TableCell>
                    <TableCell>
                      <CustomMaskedInput
                        disableUnderline
                        mask='money'
                        value={functions.addMoneyMask(String(paymentMethods[customValue.key]))}
                        onChange={(value: any) => handleCustomValue(customValue.key, value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div className='m24' />
            <Typography variant='body2'>
              <Icon style={{ marginRight: 8 }} fontSize='inherit'>
                error_outline
              </Icon>
              Nas formas de pagamento não customizadas será enviado o valor da compra.
            </Typography>
          </Fragment>
        )}
      </FormControl>
    </Fragment>
  );
}

export default styles(SendValues);
